import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiHeart } = FiIcons;

const Hero = () => {
  return (
    <section className="pt-24 pb-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8"
          >
            <img 
              src="https://github.com/mike3011/Bilder/blob/main/3.png?raw=true" 
              alt="K³ Logo" 
              className="h-32 md:h-48 w-auto mx-auto mb-6"
            />
            <div className="flex items-center justify-center mb-2">
              <SafeIcon icon={FiHeart} className="text-azure-600 text-xl mr-2" />
              <span className="text-gray-600">Künstliche Intelligenz macht deine Kundenkommunikation einfach</span>
              <SafeIcon icon={FiHeart} className="text-azure-600 text-xl ml-2" />
            </div>
          </motion.div>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-gray-700 mb-12 max-w-3xl mx-auto leading-relaxed"
          >
            Wir zeigen, was mit KI-Automatisierung möglich ist – klar, verständlich, zukunftsorientiert für kleine und mittlere Unternehmen.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <a
              href="https://cal.meetergo.com/mike-trepte/15-min-telefonat-kostenfrei"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-azure-600 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-azure-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              Kostenloses Erstgespräch buchen
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;